import {MenuComponent} from '@/_metronic/assets/ts/components'
import {DropdownSelect} from '@/_metronic/partials/content/dropdown-select/DropdownSelect'
import PropagateWrapper from '@/_metronic/partials/content/propagate/PropagateWrapper'
import {useEffect, useState} from 'react'
import {useFilterReportSalesBudget} from '../../core/FilterReportSalesBudgetProvider'
import {useQueryRequestMonthly} from '../../core/QueryRequestMonthlyProvider'
import {initialFilter} from '../../core/_models'
import {FilterDropdownBrand} from './FilterDropdownBrand'
import {FilterDropdownCity} from './FilterDropdownCity'
import {FilterDropdownOutlet} from './FilterDropdownOutlet'
import {FilterDropdownRegion} from './FilterDropdownRegion'
import {FilterDropdownSubBrand} from './FilterDropdownSubBrand'
import { initialFilterEmployee } from '@/app/core/employee/_model'
import { COM_JOB_ID, COM_JOB_ID2 } from '@/_metronic/helpers/crud-helper/consts'
import { getEmployeeDropdown } from '@/app/core/employee/_requests'
import { DropdownAsyncSelect } from '@/_metronic/partials/content/dropdown-select/DropdownAsyncSelect'

const optionsArea = [
  {value: 'WIB', label: 'WIB'},
  {value: 'WITA', label: 'WITA'},
  {value: 'WIT', label: 'WIT'},
]

const optionsMonth = [
  {value: '1', label: 'January'},
  {value: '2', label: 'February'},
  {value: '3', label: 'March'},
  {value: '4', label: 'April'},
  {value: '5', label: 'May'},
  {value: '6', label: 'June'},
  {value: '7', label: 'July'},
  {value: '8', label: 'August'},
  {value: '9', label: 'September'},
  {value: '10', label: 'October'},
  {value: '11', label: 'November'},
  {value: '12', label: 'December'},
]

const FilterReportSalesBudgetMonthlyForm = ({closeModal}) => {
  const {updateFilterReportSalesBudgetFormMonthlyValue, filterReportSalesBudgetFormMonthlyValue} =
    useFilterReportSalesBudget()
  const {updateState} = useQueryRequestMonthly()
  const [filterValue, setFilterValue] = useState(initialFilter)
  const [selectedArea, setSelectedArea] = useState<any>([])
  const [selectedMonth, setSelectedMonth] = useState<any>([])
  const [selectedOutlet, setSelectedOutlet] = useState<any>([])
  const [selectedRegion, setSelectedRegion] = useState<any>([])
  const [selectedCity, setSelectedCity] = useState<any>([])
  const [selectedBrand, setSelectedBrand] = useState<any>([])
  const [selectedSubBrand, setSelectedSubBrand] = useState<any>([])
  const [optionsYear, setOptionsYear] = useState<any>(null)
  const [selectedYear, setSelectedYear] = useState<any>(null)
  const [selectedPic, setSelectedPic] = useState<any>([])
  const currentDate = new Date()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  useEffect(() => {
    const currentYear = new Date().getFullYear()
    const years = Array.from({length: 5}, (_, index) => currentYear - 4 + index)
    setOptionsYear(years?.map((x) => ({label: x, value: x})))
    setSelectedYear({value: currentDate.getFullYear(), label: currentDate.getFullYear()})
    setFilterValue({
      ...filterValue,
      set_year: true,
      year: currentDate.getFullYear().toString(),
    })
    updateFilterReportSalesBudgetFormMonthlyValue({
      ...filterReportSalesBudgetFormMonthlyValue,
      year: {value: currentDate.getFullYear(), label: currentDate.getFullYear()},
    })

    if (filterReportSalesBudgetFormMonthlyValue) {
      setSelectedArea(filterReportSalesBudgetFormMonthlyValue.area)
      setSelectedMonth(filterReportSalesBudgetFormMonthlyValue.month)
      setSelectedOutlet(filterReportSalesBudgetFormMonthlyValue.outlet)
      setSelectedBrand(filterReportSalesBudgetFormMonthlyValue.brand)
      setSelectedSubBrand(filterReportSalesBudgetFormMonthlyValue.sub_brand)
      setSelectedYear(filterReportSalesBudgetFormMonthlyValue.year)
      setSelectedRegion(filterReportSalesBudgetFormMonthlyValue.region)
      setSelectedCity(filterReportSalesBudgetFormMonthlyValue.city)
      setSelectedPic(filterReportSalesBudgetFormMonthlyValue.pic_outlet)

      let monthList: string[] = []
      if (filterReportSalesBudgetFormMonthlyValue.month) {
        filterReportSalesBudgetFormMonthlyValue.month.forEach((element) => {
          monthList.push(element.value)
        })
      }
      let areaList: string[] = []
      if (filterReportSalesBudgetFormMonthlyValue.area) {
        filterReportSalesBudgetFormMonthlyValue.area.forEach((element) => {
          areaList.push(element.value)
        })
      }
      let outletList: string[] = []
      if (filterReportSalesBudgetFormMonthlyValue.outlet) {
        filterReportSalesBudgetFormMonthlyValue.outlet.forEach((element) => {
          outletList.push(element.value)
        })
      }
      let brandList: string[] = []
      if (filterReportSalesBudgetFormMonthlyValue.brand) {
        filterReportSalesBudgetFormMonthlyValue.brand.forEach((element) => {
          brandList.push(element.value)
        })
      }
      let subBrandList: string[] = []
      if (filterReportSalesBudgetFormMonthlyValue.sub_brand) {
        filterReportSalesBudgetFormMonthlyValue.sub_brand.forEach((element) => {
          subBrandList.push(element.value)
        })
      }
      let regionList: string[] = []
      if (filterReportSalesBudgetFormMonthlyValue.region) {
        filterReportSalesBudgetFormMonthlyValue.region.forEach((element) => {
          regionList.push(element.value)
        })
      }
      let cityList: string[] = []
      if (filterReportSalesBudgetFormMonthlyValue.city) {
        filterReportSalesBudgetFormMonthlyValue.city.forEach((element) => {
          cityList.push(element.value)
        })
      }

      setFilterValue({
        ...filterValue,
        set_area: Boolean(filterReportSalesBudgetFormMonthlyValue.area),
        area: areaList,
        set_outlet_id: Boolean(filterReportSalesBudgetFormMonthlyValue.outlet),
        outlet_id: outletList,
        set_brand_id: Boolean(filterReportSalesBudgetFormMonthlyValue.brand),
        brand_id: brandList,
        set_sub_brand_id: Boolean(filterReportSalesBudgetFormMonthlyValue.sub_brand),
        sub_brand_id: subBrandList,
        set_region_id: Boolean(filterReportSalesBudgetFormMonthlyValue.region),
        region_id: regionList,
        set_city_id: Boolean(filterReportSalesBudgetFormMonthlyValue.city),
        city_id: cityList,
        set_month: Boolean(filterReportSalesBudgetFormMonthlyValue.month),
        month: monthList,
        set_year: Boolean(filterReportSalesBudgetFormMonthlyValue.year),
        year: filterReportSalesBudgetFormMonthlyValue.year
          ? filterReportSalesBudgetFormMonthlyValue.year.value.toString()
          : currentDate.getFullYear().toString(),
      })
    }
  }, [])

  const resetData = () => {
    setSelectedOutlet([])
    setSelectedYear({value: currentDate.getFullYear(), label: currentDate.getFullYear()})
    setSelectedArea([])
    setSelectedBrand([])
    setSelectedSubBrand([])
    setSelectedRegion([])
    setSelectedCity([])
    setSelectedMonth([])
    setSelectedPic([])
    setFilterValue({
      ...filterValue,
      set_year: true,
      year: currentDate.getFullYear().toString(),
    })
    updateFilterReportSalesBudgetFormMonthlyValue(null)
    updateFilterReportSalesBudgetFormMonthlyValue({
      year: {value: currentDate.getFullYear(), label: currentDate.getFullYear()},
    })
    updateState(initialFilter)
    closeModal()
  }

   const loadComEmployees = async () => {
      try {
        const requestBody = {
          ...initialFilterEmployee,
          filter: {
            ...initialFilterEmployee.filter,
            set_job_id: true,
            job_id: [COM_JOB_ID, COM_JOB_ID2],
          },
          limit: 10_000,
        }
        const data = await getEmployeeDropdown(requestBody)
  
        // Transform data to options format expected by react-select
        const options = data.response?.data?.map((item) => ({
          value: item.guid,
          label: item.fullname,
        }))
  
        return options
      } catch (error) {
        console.error(error)
        return []
      }
    }

  const filterData = () => {
    filterValue.set_brand_id = filterValue.brand_id && filterValue.brand_id.length > 0
    filterValue.set_sub_brand_id = filterValue.sub_brand_id && filterValue.sub_brand_id.length > 0
    filterValue.set_region_id = filterValue.region_id && filterValue.region_id.length > 0
    filterValue.set_city_id = filterValue.city_id && filterValue.city_id.length > 0
    filterValue.set_area = filterValue.area && filterValue.area.length > 0
    filterValue.set_outlet_id = filterValue.outlet_id && filterValue.outlet_id.length > 0
    filterValue.set_month = filterValue.month && filterValue.month.length > 0
    filterValue.pic_outlet = filterValue.pic_outlet
    filterValue.set_pic_outlet = filterValue.pic_outlet && filterValue.pic_outlet?.length > 0
    updateState(filterValue)
    closeModal()
  }

  const onChangeSelected = (name: string) => (value) => {
    if (name === 'area') {
      setSelectedArea(value)

      let areaList: string[] = []
      if (value) {
        value.forEach((element) => {
          areaList.push(element.value)
        })
      }
      setFilterValue({
        ...filterValue,
        set_area: Boolean(areaList),
        area: areaList,
      })
      updateFilterReportSalesBudgetFormMonthlyValue({
        ...filterReportSalesBudgetFormMonthlyValue,
        area: value,
      })
    } else if (name === 'month') {
      setSelectedMonth(value)

      let monthList: string[] = []
      if (value) {
        value.forEach((element) => {
          monthList.push(element.value)
        })
      }

      setFilterValue({
        ...filterValue,
        set_month: Boolean(monthList),
        month: monthList,
      })
      updateFilterReportSalesBudgetFormMonthlyValue({
        ...filterReportSalesBudgetFormMonthlyValue,
        month: value,
      })
    } else if (name === 'year') {
      if (value) {
        setSelectedYear(value)
      } else {
        setSelectedYear({value: currentDate.getFullYear(), label: currentDate.getFullYear()})
      }
      setFilterValue({
        ...filterValue,
        set_year: true,
        year: value && value.value.toString(),
      })
      updateFilterReportSalesBudgetFormMonthlyValue({
        ...filterReportSalesBudgetFormMonthlyValue,
        year: value ? value : {value: currentDate.getFullYear(), label: currentDate.getFullYear()},
      })
    }
  }

  return (
    <>
      <div className='px-7 py-5' data-kt-user-table-filter='form'>
        <PropagateWrapper>
          <div className='row'>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Brand:</label>
                <FilterDropdownBrand
                  currentValue={selectedBrand || null}
                  onValueChange={(value) => {
                    setSelectedBrand(value)
                    let brandList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        brandList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_brand_id: Boolean(brandList),
                      brand_id: brandList,
                    })
                    updateFilterReportSalesBudgetFormMonthlyValue({
                      ...filterReportSalesBudgetFormMonthlyValue,
                      brand: selectedBrand,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Sub Brand:</label>
                <FilterDropdownSubBrand
                  currentValue={selectedSubBrand || null}
                  onValueChange={(value) => {
                    setSelectedSubBrand(value)
                    let subBrandList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        subBrandList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_sub_brand_id: Boolean(subBrandList),
                      sub_brand_id: subBrandList,
                    })
                    updateFilterReportSalesBudgetFormMonthlyValue({
                      ...filterReportSalesBudgetFormMonthlyValue,
                      sub_brand: selectedSubBrand,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Region:</label>
                <FilterDropdownRegion
                  currentValue={selectedRegion || null}
                  onValueChange={(value) => {
                    setSelectedRegion(value)
                    let regionList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        regionList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_region_id: Boolean(regionList),
                      region_id: regionList,
                    })
                    updateFilterReportSalesBudgetFormMonthlyValue({
                      ...filterReportSalesBudgetFormMonthlyValue,
                      region: selectedRegion,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>City:</label>
                <FilterDropdownCity
                  currentValue={selectedCity || null}
                  onValueChange={(value) => {
                    setSelectedCity(value)
                    let cityList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        cityList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_city_id: Boolean(cityList),
                      city_id: cityList,
                    })
                    updateFilterReportSalesBudgetFormMonthlyValue({
                      ...filterReportSalesBudgetFormMonthlyValue,
                      city: selectedCity,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Area:</label>
                <DropdownSelect
                  options={optionsArea}
                  value={selectedArea}
                  onChange={onChangeSelected('area')}
                  placeholder='All Area'
                  isMulti
                  isClearable
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Outlet:</label>
                <FilterDropdownOutlet
                  placeholder='All Outlet'
                  currentValue={selectedOutlet || null}
                  onValueChange={(value) => {
                    setSelectedOutlet(value)
                    let outletList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        outletList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_outlet_id: Boolean(outletList),
                      outlet_id: outletList,
                    })
                    updateFilterReportSalesBudgetFormMonthlyValue({
                      ...filterReportSalesBudgetFormMonthlyValue,
                      outlet: selectedOutlet,
                    })
                  }}
                  isDisabled={false}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Month:</label>
                <DropdownSelect
                  options={optionsMonth}
                  isMulti
                  isClearable
                  value={selectedMonth}
                  onChange={onChangeSelected('month')}
                  placeholder='All Month'
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Year:</label>
                <DropdownSelect
                  options={optionsYear}
                  placeholder='Select Year'
                  value={selectedYear}
                  onChange={onChangeSelected('year')}
                  isClearable
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>PIC:</label>
                <DropdownAsyncSelect
                      loadOptions={loadComEmployees}
                      value={selectedPic || null}
                      onChange={(value: any) => {
                        setSelectedPic(value)
                        let picList: string[] = []
                        if (value) {
                          value.forEach((element) => {
                            picList.push(element.value)
                          })
                        }
                        setFilterValue({
                          ...filterValue,
                          set_pic_outlet: Boolean(picList.length > 0),
                          pic_outlet: picList,
                        })
                        updateFilterReportSalesBudgetFormMonthlyValue({
                          ...filterReportSalesBudgetFormMonthlyValue,
                          pic_outlet: value,
                        })
                      }}
                      placeholder='All COM & Manager Regional'
                      isMulti
                    />
              </div>
            </div>
          </div>
        </PropagateWrapper>
        <div className='d-flex justify-content-end'>
          <button
            type='button'
            // disabled={isLoading}
            onClick={resetData}
            className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
            data-kt-menu-dismiss='true'
            data-kt-user-table-filter='reset'
          >
            Reset
          </button>
          <button
            // disabled={isLoading}
            type='button'
            onClick={filterData}
            className='btn btn-primary fw-bold px-6'
            data-kt-menu-dismiss='true'
            data-kt-user-table-filter='filter'
          >
            Apply
          </button>
        </div>
      </div>
    </>
  )
}

export {FilterReportSalesBudgetMonthlyForm}
